<div class="loader-container">
	<app-loader
		[enableCircle]="true"
		[isActive]="this.isLoading"
		[width]="20"
	></app-loader>
	<h1 matDialogTitle>
		<div class="flex flex-row items-center justify-start">
			<div>{{ 'project.create' | translate }}</div>
			<div class="flex-auto"></div>
			<button
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</h1>
	<mat-dialog-content>
		<form
			(onsubmit)="this.submit()"
			[formGroup]="this.projectForm"
			class="flex flex-col items-stretch justify-start gap-3"
		>
			<mat-form-field
				appearance="fill"
				class="w-full"
			>
				<mat-label>Name</mat-label>
				<input
					cdkInitialFocus
					formControlName="name"
					matInput
					required
					type="text"
				>
				<mat-error *ngIf="this.formNameErrors as error">{{
					error.content | translate: error.args || {}
				}}</mat-error>
			</mat-form-field>

			<div class="flex flex-col">
				<mat-form-field
					(click)="$event.preventDefault(); openTemplatePicker()"
					appearance="fill"
					class="w-full"
				>
					<mat-label>{{ 'template' | translate }}</mat-label>
					<input
						[value]="projectForm.value.template?.name"
						class="cursor-pointer"
						matInput
						readonly
						type="text"
					>
					<button
						(click.prevent)="projectForm.patchValue({ template: null })"
						*ngIf="projectForm.value.template"
						mat-icon-button
						matSuffix
						tabindex="-1"
						type="button"
					>
						<mat-icon>clear</mat-icon>
					</button>
				</mat-form-field>
				<div
					*ngIf="projectForm.value.template"
					class="rounded flex flex-col bg-neutral-500/10 px-3.5 py-2 mb-2 dark:bg-black/10"
				>
					<div class="flex">
						<mat-checkbox
							color="primary"
							formControlName="templateCopyRate"
						>
							{{ 'project.template.rateCopy' | translate }}
						</mat-checkbox>
					</div>
					<div class="flex">
						<mat-checkbox
							color="primary"
							formControlName="templateCopyTasks"
						>
							{{ 'project.template.tasksCopy' | translate }}
						</mat-checkbox>
					</div>
					<div class="flex">
						<mat-checkbox
							[disabled]="!projectForm.value.templateCopyTasks"
							color="primary"
							formControlName="templateCopyTaskAssign"
						>
							{{ 'project.template.tasksCopyAssign' | translate }}
						</mat-checkbox>
					</div>
				</div>
			</div>
			<div class="flex flex-col gap-2 sm:flex-row sm:items-start">
				<mat-form-field
					(click)="$event.preventDefault(); this.openClientPicker()"
					appearance="fill"
					class="flex-auto"
				>
					<mat-label>{{ 'Client' | translate }}</mat-label>
					<input
						[value]="projectForm.value.client | defaultEntityTranslate: 'client' : 'client.none'"
						class="cursor-pointer"
						matInput
						readonly
						type="text"
					>
					<button
						(click.native)="this.setClient()"
						*ngIf="projectForm.value.client && !projectForm.value.client.useAsDefault"
						mat-icon-button
						matSuffix
						tabindex="-1"
						type="button"
					>
						<mat-icon>clear</mat-icon>
					</button>
					<mat-error *ngIf="!projectForm.value.client"
						>{{ 'errors.required' | translate: { field: 'Client' | translate } }}*</mat-error
					>
				</mat-form-field>
				<mat-form-field
					appearance="fill"
					class="project-color-field"
				>
					<mat-label>{{ 'project.color' | translate }}</mat-label>
					<input
						autocomplete="off"
						formControlName="colorText"
						matInput
						maxlength="7"
						spellcheck="false"
					>
					<mat-error
						*ngIf="projectForm.controls.colorText.touched && projectForm.controls.colorText.errors?.invalidHex"
					>
						{{ 'errors.invalidHex' | translate }}
					</mat-error>
					<div
						(colorPickerChange)="onColorPicked($event)"
						[colorPicker]="projectForm.value.color"
						[cpAlphaChannel]="'disabled'"
						[cpCmykEnabled]="false"
						[cpOutputFormat]="'hex'"
						[cpPosition]="'bottom'"
						[cpPositionOffset]="'24px'"
						[matTooltip]="'project.color' | translate"
						[style.backgroundColor]="projectForm.value.color"
						class="project-color-dot project-color-dot--suffix color-picker-material"
						matSuffix
					></div>
				</mat-form-field>
			</div>
			@if (showAdvancedSettings) {
			<mat-accordion
				[hideToggle]="false"
				[multi]="true"
				class="mat-elevation-z0 mat-dialog-content-fluid mb-3"
				displayMode="flat"
			>
				<mat-expansion-panel
					[(expanded)]="showAdvanced"
					[hideToggle]="false"
					class="mat-elevation-z0"
				>
					<mat-expansion-panel-header>{{ 'settings.additional' | translate }}</mat-expansion-panel-header>
					<ng-template matExpansionPanelContent>
						<div class="flex flex-col items-stretch justify-start">
							<mat-form-field appearance="fill">
								<mat-label>{{ 'project.externalId.label' | translate }}</mat-label>
								<input
									formControlName="externalId"
									matInput
									type="text"
								>
							</mat-form-field>
							<mat-form-field appearance="fill">
								<mat-label class="mat-typography">{{
									'filter-toolbar.billable-filter' | translate
								}}</mat-label>
								<mat-select formControlName="billing">
									<mat-option [value]="true">{{
										'filter-toolbar.projects.billable-on' | translate
									}}</mat-option>
									<mat-option [value]="false">{{
										'filter-toolbar.projects.billable-off' | translate
									}}</mat-option>
								</mat-select>
							</mat-form-field>
							<mat-form-field appearance="fill">
								<mat-label>{{ 'project.privateToggle' | translate }}</mat-label>
								<mat-select formControlName="private">
									<mat-option [value]="true">{{ 'project.private.state' | translate }}</mat-option>
									<mat-option [value]="false">{{ 'project.public.state' | translate }}</mat-option>
								</mat-select>
							</mat-form-field>
							<mat-form-field appearance="fill">
								<mat-label>{{ 'project.budget._' | translate }}</mat-label>
								<mat-select formControlName="estimationType">
									<mat-option value="task">{{ 'project.budget.task-option' | translate }}</mat-option>
									<mat-option value="manual">{{
										'project.budget.manual-option' | translate
									}}</mat-option>
								</mat-select>
							</mat-form-field>
							<ng-container *ngIf="this.projectForm?.value?.estimationType === 'manual'">
								<tg-duration-input-control
									[inputPlaceholder]="'timer.time.duration' | translate"
									formControlName="estimation"
								>
									<ng-template
										durationInputControl
										let-control="control"
										let-inputPlaceholder="inputPlaceholder"
									>
										<mat-form-field
											appearance="fill"
											fxFill
										>
											<mat-label>{{ 'project.budget.manual-input' | translate }}</mat-label>
											<input
												[formControl]="control"
												autocomplete="off"
												matInput
												type="text"
											>
										</mat-form-field>
									</ng-template>
								</tg-duration-input-control>
							</ng-container>
						</div>
					</ng-template>
				</mat-expansion-panel>
			</mat-accordion>
			}
		</form>
	</mat-dialog-content>
	<mat-dialog-actions
		[matTooltip]="'workspace.errors.admin-create-project' | translate"
		[matTooltipDisabled]="this.workspace$createPermission | async"
		class="mat-action-filled"
	>
		<button
			(click)="this.submit()"
			[disabled]="this.projectForm.invalid || !(this.workspace$createPermission | async)"
			class="mat-action-filled"
			color="primary"
			mat-flat-button
		>
			{{ 'project.create' | translate }}
		</button>
	</mat-dialog-actions>
</div>
<ng-template #createBlocked>
	<mat-dialog-actions
		align="center"
		class="m-0"
	>
		<p
			class="text-warn m-0 text-center"
			translate
		>
			workspace.errors.admin-create-project
		</p>
	</mat-dialog-actions>
</ng-template>
